import styled from '@mui/system/styled'
import { Row } from 'src/components/Layout/Styled'

export const StyledUnderlinedRow = styled(Row)(({ theme }) => ({
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
  gap: theme.spacing(1.5),
  borderBottom: '1px solid',
  borderColor: theme.palette?.primary?.main,
}))
